import { NextPage } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import { useFetchNewsIfNeeded, useSingleNews } from "../../redux/newsfeed";
import { NewsSection } from "../../components/vijesti/NewsSection";

const VijestPage: NextPage = () => {
  useFetchNewsIfNeeded();
  const router = useRouter();
  const { slug } = router.query;
  const news = useSingleNews(typeof slug === "string" ? slug : "");
  return (
    <>
      <Head>
        <title>{news?.Naslov || "Vijest ne postoji"}a</title>
      </Head>
      {news && <NewsSection news={news} />}
    </>
  );
};

export default VijestPage;
